import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { setBloodProductTypeOptions } from '../store/options.actions'
import { PatientDemographicsService } from '../../patientDemographics/services/patientDemographics.service'

export function* getBloodProductTypeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientDemographicsService = new PatientDemographicsService(serviceId)

  try {
    const bloodTypeResponse: IOptionsResponse = yield call([
      patientDemographicsService,
      patientDemographicsService.getBloodTypeOptions,
    ])
    const { entity } = bloodTypeResponse
    yield put(setBloodProductTypeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getBloodProductTypeOptions() error: ${e}`))
  }
}
export function* getBloodProductTypeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getBloodProductTypeOptions)
}
